$(document).on("ready", function () {
  if (!$("section.main.people.legends").length) {
    return;
  }
  $(".main-search-form-container").hide();
});
